import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../mock";

const FAQ = () => {
  return (
    <section id="faq" className="relative py-20 lg:py-28 bg-cream">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#daae9c]">
            <span className="w-6 h-px bg-sterling-dark" />
            Have Questions?
            <span className="w-6 h-px bg-sterling-dark" />
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-[1.05] text-balance">
            We’ve got{" "}
            <span className="italic text-[#daae9c]">answers.</span>
          </h2>
          <p className="mt-5 text-ink/70">
            Everything you need to know about our services, bookings and
            scheduling.
          </p>
        </div>

        <div className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white rounded-2xl border border-[#ead8c9] px-6 data-[state=open]:border-sterling-dark transition-colors"
              >
                <AccordionTrigger className="text-left font-serif-display text-lg text-ink hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink/70 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
